// The help nav only shows h3 headings and h4 subheadings - this filters out all the h5
const filterHeadingsByDepth = headings =>
  headings.filter(heading => heading.depth < 5);

// Remap the headings array to add a subHeadings array to each heading
const mapHeadingsForSubheading = headings =>
  headings.map(heading => {
    return { ...heading, subHeadings: [] };
  });

// Iterate through headings and sort h4 subheadings as children of respective h3 headings
const sortSubheadingsIntoHeadings = headings => {
  const mappedHeadings = [];
  for (let i = 0; i < headings.length; i++) {
    const currentHeading = headings[i];
    // Subheadings are h4 - so all subsequent headings with depth 4 are subheadings of current heading
    while (headings[i + 1] && headings[i + 1].depth === 4) {
      currentHeading.subHeadings.push(headings[i + 1]);
      i < headings.length && i++;
    }
    mappedHeadings.push(currentHeading);
  }
  return mappedHeadings;
};

// Takes possible heading/subheading and returns true if is h4 subheading 
// Used to determine nature of any hash already present on page load
const isSubheading = (possibleHeading, mappedHeadings) => {
  let isSubheading = true;
  mappedHeadings.forEach(heading => {
    if (heading.id === possibleHeading.id) {
      isSubheading = false;
    }
  });
  return isSubheading;
};

// Given an h4 subheading, returns its h3 heading parent. 
// Used to activate correct h3 heading on page load if initial hash is subheading
const findParentHeadingFromSubheading = (currentSubheading, mappedHeadings) => {
  let currentHeading = null;
  mappedHeadings.forEach(heading => {
    heading.subHeadings.forEach(subheading => {
      if (subheading.id === currentSubheading.id) {
        currentHeading = heading;
      }
    });
  });
  return currentHeading;
};

export {
  filterHeadingsByDepth,
  mapHeadingsForSubheading,
  sortSubheadingsIntoHeadings,
  isSubheading,
  findParentHeadingFromSubheading
};
